const state = {
  loading: false
}

const getters = {
  loading: state => state.loading
}

const mutations = {
  SET_LOADING: (state, loading) => state.loading = loading
}

export default {
  state,
  getters,
  mutations
}